import React from 'react'
import { Fonts, TextSize, Weight } from '../../typography/text/index'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

const FormWrapper = styled.div`
  width: 100%;
  form {
    display: flex;
    gap: 20px;
    margin-top: 10px;
    ${({ theme }) => theme.mediaWidth.Mobile`
     flex-direction: column;
     gap: 10px;
    `};
    input {
      height: 30px;
      box-sizing: border-box;
      border-radius: 36px;
      border: 2px solid ${GLOBAL_COLORS.white};
      background: ${GLOBAL_COLORS.customBlack};
      color: ${GLOBAL_COLORS.white};
      padding: 10px 20px;
      font-weight: ${Weight.Regular};
      font-size: ${TextSize.small};
      min-width: 76%;
      :focus {
        border: 3px solid ${GLOBAL_COLORS.white};
      }
      :focus-visible {
        outline: none;
      }
    }
  }
`

const SubmitButton = styled.button`
  width: 105px;
  height: 30px;
  font-family: ${Fonts.DMSans};
  background-color: ${GLOBAL_COLORS.white};
  color: ${GLOBAL_COLORS.customBlack};
  cursor: pointer;
  border-radius: 30px;
  border: none;
  font-weight: 500;
  font-size: ${TextSize.small};
  transition: 0.4s all;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
  ${({ theme }) => theme.mediaWidth.Mobile`
     width: 100%;
  `};
`

export const EmailInput: React.FC = () => {
  return (
    <FormWrapper>
      <form action="https://finance.us6.list-manage.com/subscribe/post" method="post">
        <input type="hidden" name="u" value="f646021228a7fae2ed45a17b9" />
        <input type="hidden" name="id" value="cd4f932e89" />
        <input
          placeholder={'example@phuture.finance'}
          type="email"
          autoCapitalize="off"
          autoCorrect="off"
          name="MERGE0"
          id="MERGE0"
        />
        <SubmitButton type="submit">Subscribe</SubmitButton>
      </form>
    </FormWrapper>
  )
}
